import { useState } from "react";

import { useProjecaoFormulario } from "../../projecao-formulario/use-projecao-formulario";
import type { EtapaProjecaoParams } from "./types-etapa-projecao";

const SEM_ALVO = { obraTipoObraId: "" };

export function useEtapaProjecao({
  obraId,
  ativa,
  alvo,
  obra,
  cotacaoDaObra,
  resumo,
  enviar,
  enviando,
}: EtapaProjecaoParams) {
  const [tentou, setTentou] = useState(false);
  const {
    corpo,
    concluidoValido,
    cotacaoAlterada,
    isDirty,
    consultaOpcoes,
    cotacaoDialog,
    descartar,
    ...formulario
  } = useProjecaoFormulario({
    obraId,
    alvo: alvo ?? SEM_ALVO,
    obra,
    cotacaoDaObra,
    previaAposMudanca: true,
    ativo: ativa && alvo !== null,
    mostrarObrigatorios: tentou,
  });

  const completo = alvo !== null && corpo !== null && concluidoValido;

  return {
    isDirty,
    cotacaoAlterada,
    descartar: () => {
      descartar();
      setTentou(false);
    },
    concluir: () => {
      if (enviando) return;
      setTentou(true);
      if (completo && corpo) void enviar(corpo);
    },
    cotacaoDialog,
    view: {
      ...formulario,
      resumo,
      estado: consultaOpcoes.status,
      errorMessage: consultaOpcoes.errorMessage,
      recarregar: consultaOpcoes.recarregar,
      enviando,
    },
  };
}
